import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import keycloakConfig from '../../keycloak'
import Cookies from 'js-cookie'
import { decodeRoles } from '../../helpers/decode'
import { t } from 'i18next'

export const initializeKeycloak = createAsyncThunk(
  'auth/customLogin',
  async (
    // `clientId` is optional: when omitted (today's behaviour, unchanged),
    // it defaults to the single env-configured tenant client. It's only
    // ever different when Login.tsx resolved a self-service organization's
    // own (public, secret-less) Keycloak client via /auth/resolve-tenant.
    credentials: { username: string; password: string; clientId?: string },
    { rejectWithValue }
  ) => {
    try {
      const { username, password } = credentials
      const resolvedClientId = credentials.clientId || keycloakConfig.clientId
      // The default client is confidential (needs a secret); any
      // dynamically-provisioned organization client is created as PUBLIC
      // (see grc-back KeycloakAdminService), so it never needs one.
      const isDefaultClient = resolvedClientId === keycloakConfig.clientId

      const params: Record<string, string> = {
        client_id: resolvedClientId,
        grant_type: 'password',
        username,
        password,
      }
      if (isDefaultClient) {
        params.client_secret = keycloakConfig.clientSecret
      }

      const response = await axios.post(
        `${keycloakConfig.url}/protocol/openid-connect/token`,
        new URLSearchParams(params),
        {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        }
      )

      if (response.status !== 200) {
        return rejectWithValue('Login failed')
      }

      const { access_token: token, refresh_token, id_token } = response.data
      console.log('response.data', response.data)
      const keycloak = {
        token,
        id_token,
        refresh_token,
        username,
      }
      localStorage.setItem('token', token || '')
      localStorage.setItem('refreshToken', refresh_token || '')
      localStorage.setItem('username', username || '')
      localStorage.setItem('tenantClientId', resolvedClientId)
      Cookies.set('token', token, { expires: 7, secure: true })
      Cookies.set('refreshToken', refresh_token, { expires: 7, secure: true })
      Cookies.set('username', username, { expires: 7, secure: true })
      localStorage.setItem('lastRefreshTime', Date.now().toString())
      console.log('Data.now().toString()', Date.now().toString())

      const roles = decodeRoles(token, resolvedClientId)

      if (!roles) {
        return rejectWithValue(t('login.error'))
      }

      return {
        keycloak,
        authenticated: true,
        username,
        token,
        roles,
      }
    } catch (error: any) {
      console.error('API error:', error)
      return rejectWithValue(t('login.invalidCredentials') || 'Login failed')
    }
  }
)
